import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/enrols.action'
import enrolList, { Query } from 'api/enrols/List'
import { ActionWithPayload } from 'helpers/redux-actions.helper'

function getList(q?: Query) {
  return enrolList(q)
}
const pattern = fromActions.ENROL_LIST_GET

export type EnrolListAction = ActionWithPayload<
  typeof pattern,
  {
    q?: Query
  }
>

function* enrolListEffectSaga(action: EnrolListAction) {
  const { payload } = action
  const { q } = { ...payload }
  try {
    const data = yield call(getList, q)
    yield put(fromActions.Actions.enrolListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* enrolListWatcherSaga() {
  yield takeLatest(fromActions.ENROL_LIST_GET, enrolListEffectSaga)
}
